<template>
      <div no-body > 
      <b-row>
        <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend><span class="p-2">Filter</span></b-input-group-prepend>
              <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblCompany"
          responsive
          striped hover
          :items="items"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :filter="filter"
          @filtered="onFiltered"                
          @row-clicked="selectItem"
        >
        <template v-slot:cell(nomor)="data">
          {{ (tblData.page - 1) * tblData.limit + (data.index + 1)}}
        </template>
        <template v-slot:cell(compaddr1)="data">
          {{ data.item.compaddr1 }}
          {{ data.item.compaddr2 }}
          {{ data.item.compaddr3 }}
        </template>
        <template v-slot:cell(PhoneNo)="data">
          <span v-if="(data.item.compphone)">P.{{data.item.compphone}}</span>&nbsp;
          <span v-if="(data.item.compfax)">F.{{data.item.compfax}}</span>
        </template>
      </b-table>
      <b-row v-if="(tblData.total>10)">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>        
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols="4" label="Limit per page"  style="margin-top:0 !important;">
              <b-form-select :options="[10, 15, 20, 25, 30, 40, 50]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
</template>

<script>
import crud from "../../apis/crud";

export default {
  data() {
    return {
      fields: [
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "company",
            label: "Company Name",
            sortable: true
          },
          {
            key: "compaddr1",
            label: "Address",
            sortable: true
          },
          {
            key: "PhoneNo",
            label: "Phone/Fax",
            sortable: true
          },
      ],
      items:[],
      tblData: {
        tablename:'vwcompany',
        page: 1,
        total: 0,
        limit:10000,
        sortBy: 'company',
        sortDesc: false
      },
      filter:null
    };
  },
 props: ["holding"],  
  created: async function() {
      this.data();
  },
  mounted() {
    // Set the initial number of items
    this.tblData.total = this.items.length;
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    data: async function() {
      if (this.holding){
        this.tblData.customQuery = 'holding=' + encodeURIComponent(this.holding);
      }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.items=await crud.list(this.tblData);
      // return this.items;      
      this.tblData.total = this.items.length;
      this.tblData.limit= 10;
    },
    selectItem(item,index) {
        this.$emit("click", item);
    },  
    refresh() {
      this.$refs.tblCompany.refresh();
    }
  }
};
</script>
